module.exports = __webpack_public_path__ + "static/Atmosphare_Identitat-a879105a09f26f3fe744dc8bb863d35b.png";